import React, { Component } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import "./../../View.css";
import "./../../Grid.css";
import "./../../Form.css";
import "./../../App.css";
import ViewUtils from '../../ViewUtils';
import AuditTrial from './AuditTrial';

import { ViewContainer } from "./../../View.jsx";
import LinkDialog from "../LinkDialog";
import EnhancedTable from '../../widgets/ResponsiveTable';
import Prompt from '../../widgets/Prompt';
import EnhancedToolbar from '../../widgets/Toolbar';
import AlertItem from "../../widgets/AlertItem";

export const registrationHistoryHeadCells = [
    { id: 'FacilitatorRegistrationStartDate', numeric: false, disablePadding: true, label: 'Facilitator Registration Start Date' },
    { id: 'FacilitatorRegistrationEndDate', numeric: false, disablePadding: true, label: 'Facilitator Registration End Date' },
    { id: 'FacilitatorRegistrationStatus', numeric: false, disablePadding: true, label: 'Facilitator Registration Status' },
    { id: 'DateUpdated', numeric: false, disablePadding: true, label: 'Date Updated' },
    { id: 'UpdatedBy', numeric: false, disablePadding: true, label: 'Updated By' }
];

const utils = new ViewUtils();
const toolbarRef = React.createRef();

class RegistrationHistorySearch  extends Component {

    constructor(props) {
        super(props)
        this.state = {
            model: {
                SAQAUnitStandardID: "",
                SAQAUnitStandardTitle: "",
                FacilitatorID: this.props.location.state.FacilitatorID
            },

            linkDialogOpen: false,
            selectedAuditTrial: null,
            propmtOpen: false,
            message: "",
            messageStyle: "",
            searchParameters: [{ Name: "FacilitatorID", Value: this.props.location.state.FacilitatorID }]
        }

        this.toolbarConfig = {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'close', label: 'CLOSE', tooltip: 'Close', icon: 'CloseIcon' }
                    ]
                }
                ,
                {
                    type: "devider"
                },
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'ViewAudit', label: '', tooltip: 'View Audit Trial', icon:'AuditIcon', disabled: utils.isNull(this.state.selectedAuditTrial) }
                       
                    ]
                }
            ]
        };

    }

    handleToolbarButtonClick = (buttonId) => {
        if ("close" === buttonId) {
            this.props.history.push({
                pathname: '/facilitator',
                state: { selection: this.props.location.state.FacilitatorID }
            });
        }
        else if ("ViewAudit" === buttonId) {
            this.setState({ linkDialogOpen: true, message: "" })
        }

    }

    successCallback = (response) => {
        if (!utils.isNull(response.EntityId) && response.EntityId === 0) {
            this.setState({
                selectedAuditTrial: null,
                message: response.Message,
                messageStyle: response.MessageType.toLowerCase()
            });
            //Force a refresh
            this.setState({ searchParameters: JSON.parse(JSON.stringify(this.state.searchParameters)) })
        }
        else if (!utils.isNull(response.Message) && response.Message !== "") {
            this.setState({
                message: response.Message,
                messageStyle: response.MessageType.toLowerCase()
            })
        }
    }

    unlinkUnitstandard(url) {
        this.setState({ promptOpen: false }, () => {
            toolbarRef.current.setButtonDisabled("unlink", true);
        })

        let fullUrl = `${url}?id=${this.state.selectedAuditTrial}&facilitatorId=${this.props.location.state.FacilitatorID}`
        utils.invokeUrl(fullUrl, this.successCallback, null)
    }

    postLinkHandler(isCancel, linked) {
        if (linked === true) {
            this.setState({
                searchParameters: JSON.parse(JSON.stringify(this.state.searchParameters)),
                linkDialogOpen: false, selectedAuditTrial: null
            });
        }
        else if (isCancel === true) {
            this.setState({
                linkDialogOpen: false
            })
        }
    }

    handleSelectionChange = (selection) => {
        if (selection !== null && selection.length !== 0) {
            this.setState({
                selectedAuditTrial: selection[0].Id,
                message: "",
                messageStyle: ""
            });
        } else {
            this.setState({
                selectedAuditTrial: null,
                message: "",
                messageStyle: ""
            });
        }
        toolbarRef.current.setButtonDisabled("ViewAudit", selection === null || selection.length === 0);
    }

    closePrompt = () => {
        this.setState({ propmtOpen: false })
    }

    render() {
        return (
            <ViewContainer mode={this.props.mode} title="">
                <p className="breadcrumbs">
                    {"Facilitator > Registration History" + (this.props.location.state !== null ? " > " + this.props.location.state.FacilitatorName + " - " + this.props.location.state.FacilitatorIDNo : "> Add")}
                </p>

                <AlertItem message={this.state.message} alertStyle={this.state.messageStyle} />

                <div className="searchResults">
                    <EnhancedToolbar
                        highlight={false}
                        buttonClickHandler={(buttonId) => this.handleToolbarButtonClick(buttonId)}
                        ref={toolbarRef}
                        config={this.toolbarConfig} />

                    <EnhancedTable
                        headCells={registrationHistoryHeadCells}
                        dataUrl={`api/sims/facilitatorregistrationhistory/GetFacilitatorRegistrationHistory`}
                        height="50vh"
                        onSelectionChange={(selection) => { this.handleSelectionChange(selection) }}
                        searchParameters={this.state.searchParameters} paged={true} />
                </div>

                <LinkDialog open={this.state.linkDialogOpen} type={this.state.selectedLinkType}
                    title={`Audit Trail: ${this.props.location.state.FacilitatorName}`}
                    closeHandler={(isCancelled, linked) => this.postLinkHandler(isCancelled, linked)}
                    dialogTitle={`Audit Trail: ${this.props.location.state.FacilitatorName}`}
                    linkName={"Audit Trail"} postUrl={"api/indicium/UnitStandardSetup/linkFacilitatorUnitStandards"}
                    selectionId={this.props.location.state.FacilitatorID}
                >

                    <AuditTrial dataUrl="api/sims/facilitatorregistrationhistory/GetRegistrationAuditTrail"
                        multiSelect={false} showTitle={false}
                        Id={this.state.selectedAuditTrial}
                    />
                </LinkDialog>
            </ViewContainer>
        );
    }
}

export default withRouter(
    connect()(RegistrationHistorySearch )
);
